import React, { useEffect, useState } from 'react'
import ImageCarousel from './ImageCarousel'

 

const Header = () => {
    const [data, setData] = useState(null)
    const BASE_URl = window.location.origin
    useEffect(()=>{
        fetch(`${BASE_URl}/api/showHeaderImages`, {
            method: 'GET',
            credentials: 'include'
        }).then((res) => res.json())
        .then((data) => {setData(data.images)})
        .catch((error) => console.log(error))
    },[BASE_URl])

  return (
    <div className='mt-14'>
      {<ImageCarousel
      images = {data}
      />}
    </div>
  )
}

export default Header
